const verificationTypes = [
  {
    id: "nid",
    name: "NID",
  },
  {
    id: "passport",
    name: "Passport",
  },
  {
    id: "drivers_license",
    name: "Drivers license",
  },
  {
    id: "birth_certificate",
    name: "Birth Certificate",
  },
];

export { verificationTypes };
